/**
 * sz-v2-ev — GET /external/engineer?sn=
 * @see sections/sz-v2-ev-cert-verify.liquid
 */

(function (global) {
  'use strict';

  /** @typedef {{ img?: string, level?: string, sn?: string, first_name?: string, last_name?: string, trained_at?: number, expired_at?: number, training_models?: unknown[], status?: number }} EngineerCertData */
  /** @typedef {{ code: number, message?: string, data?: EngineerCertData|null }} EngineerCertEnvelope */

  var PATH = '/external/engineer';

  function normalizeBase(base) {
    if (!base || typeof base !== 'string') return '';
    return base.replace(/\/+$/, '');
  }

  /**
   * @param {number|string|null|undefined} ts
   * @returns {number|null} milliseconds
   */
  function tsToMs(ts) {
    if (ts == null || ts === '') return null;
    var n = Number(ts);
    if (!Number.isFinite(n)) return null;
    return n < 1e12 ? n * 1000 : n;
  }

  /**
   * @param {unknown} models
   * @returns {string}
   */
  function formatTrainingModels(models) {
    if (!models || !Array.isArray(models)) return '';
    return models
      .map(function (m) {
        if (m == null) return '';
        if (typeof m === 'string') return m.trim();
        if (typeof m === 'object' && m !== null && 'name' in m)
          return String(/** @type {{name?:string}} */ (m).name || '').trim();
        try {
          return JSON.stringify(m);
        } catch (e) {
          return '';
        }
      })
      .filter(Boolean)
      .join(' & ');
  }

  /**
   * HTTPS 页面禁止请求明文 http（混合内容）。baseUrl 请填 https 完整地址，或同源路径前缀如 /apps/your-proxy（走 App Proxy / 反代）。
   * @param {string} baseUrl
   * @param {string} sn
   * @returns {string}
   */
  function buildRequestUrl(baseUrl, sn) {
    var base = normalizeBase(baseUrl);
    var combined = base + PATH;
    var url;
    if (/^https?:\/\//i.test(combined)) {
      url = new URL(combined);
    } else {
      var origin =
        typeof global.location !== 'undefined' && global.location.origin ? global.location.origin : '';
      if (!origin) {
        throw new Error('SZ_V2_EV_ENGINEER_API: use absolute https API URL');
      }
      var rel = combined.startsWith('/') ? combined : '/' + combined;
      url = new URL(rel, origin);
    }
    url.searchParams.set('sn', String(sn || '').trim());
    return url.toString();
  }

  /**
   * @param {string} baseUrl
   */
  function warnApiMisconfig(baseUrl) {
    if (typeof global.console === 'undefined' || !global.console.warn) return;
    var b = String(baseUrl || '');
    var loc = typeof global.location !== 'undefined' ? global.location : null;
    var pageHttps = loc && loc.protocol === 'https:';

    if (pageHttps && /^http:\/\//i.test(b)) {
      global.console.warn(
        '[sz-v2-ev] Mixed content: storefront is HTTPS but api_base_url uses http:// — browser will block fetch(). Use App Proxy / reverse proxy under your shop domain, or serve API over HTTPS.'
      );
    }
    if (/^https:\/\/(?:\d{1,3}\.){3}\d{1,3}(?::\d+)?(?:\/|$)/i.test(b)) {
      global.console.warn(
        '[sz-v2-ev] Request uses https:// + raw IP. Dev servers on :8000 are usually HTTP-only; TLS handshake fails (Network shows provisional headers, empty response). Fix: use http only via same-origin proxy, or put HTTPS on a real domain.'
      );
    }
  }

  /**
   * @param {string} baseUrl
   * @param {string} sn
   * @param {RequestInit} [init]
   * @returns {Promise<EngineerCertEnvelope>}
   */
  function fetchCertificate(baseUrl, sn, init) {
    warnApiMisconfig(baseUrl);
    var reqUrl = buildRequestUrl(baseUrl, sn);
    return fetch(reqUrl, Object.assign({ method: 'GET', credentials: 'omit' }, init || {})).then(function (res) {
      return res.text().then(function (text) {
        /** @type {unknown} */
        var body = null;
        try {
          body = text ? JSON.parse(text) : null;
        } catch (e) {
          body = null;
        }
        if (!res.ok) {
          var msg =
            body && typeof body === 'object' && body !== null && 'message' in body
              ? String(/** @type {{message?:string}} */ (body).message || '')
              : '';
          var err = new Error(msg || 'HTTP ' + res.status);
          /** @type {{ status?: number, body?: unknown }} */ (err);
          err.status = res.status;
          err.body = body;
          throw err;
        }
        return /** @type {EngineerCertEnvelope} */ (body || { code: -1, message: 'Invalid JSON' });
      });
    });
  }

  global.SZ_V2_EV_ENGINEER_API = {
    PATH: PATH,
    buildRequestUrl: buildRequestUrl,
    fetchCertificate: fetchCertificate,
    tsToMs: tsToMs,
    formatTrainingModels: formatTrainingModels,
  };
})(typeof window !== 'undefined' ? window : globalThis);
